(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[700],{

/***/ 7737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Quantity; }
/* harmony export */ });
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _data_fragments_checkout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41989);
/* harmony import */ var _hooks_useMessage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5528);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50456);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96026);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_range__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42124);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_9__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          mutation setBagsRequiredPreferences($websiteId: ID, $bagsRequired: Float) {\n            setUserPreferences(websiteId: $websiteId, bagsRequired: $bagsRequired) {\n              ...checkoutPreferences\n            }\n          }\n          ",
        "\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









function Quantity(props) {
    var showMessage = (0,_hooks_useMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var mutate = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useMutate */ .Tu)();
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var bagsRequired = props.bagsRequired, maxBagsAllowed = props.maxBagsAllowed, calculatedBagsRequired = props.calculatedBagsRequired;
    var value1 = bagsRequired || calculatedBagsRequired || 1;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!value1 || !maxBagsAllowed) return;
        if (value1 > maxBagsAllowed) updateBagsRequiredPreferences(maxBagsAllowed);
    }, [
        value1,
        maxBagsAllowed
    ]);
    var updateBagsRequiredPreferences = function() {
        var _ref = _asyncToGenerator(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(value) {
            return _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return mutate({
                            mutation: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_8__["default"])(_templateObject(), _data_fragments_checkout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z),
                            variables: {
                                websiteId: websiteId,
                                bagsRequired: Number(value)
                            }
                        });
                    case 3:
                        _ctx.next = 8;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                        showMessage(_ctx.t0);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return function updateBagsRequiredPreferences(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var onChange = function(event) {
        updateBagsRequiredPreferences(event.target.value);
    };
    var renderOptions = function() {
        return lodash_range__WEBPACK_IMPORTED_MODULE_7___default()(1, maxBagsAllowed + 1).map(function(amount) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                value: String(amount),
                children: amount
            }, amount);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_9___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("select", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_9___default().select),
            onChange: onChange,
            value: String(value1),
            children: renderOptions()
        })
    });
};


/***/ }),

/***/ 88511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data_fragments_preferences_timeFieldPreferencesFragment_main__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34566);
/* harmony import */ var _data_fragments_preferences_updateAddressFragment_main__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14482);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment checkoutDeliveryPreferences on Preference {\n    _id\n    websiteId\n    deliveryType\n    tableName\n    timeLabel\n    time\n    placeId\n    itsStoreOpenAtTime\n    dropOffType\n    itsStoreOpenAtTime\n    directions {\n      duration\n    }\n    website {\n      _id\n      name\n    }\n    address {\n      _id\n      placeId\n      address\n      addressSecondary\n      addressLine2\n      acceptsNoLine2\n      location\n      comment\n    }\n    store {\n      _id\n      name\n      acceptServeSchedulingOrders\n      schedulingOrdersDays\n      currentPreparationDuration\n      currentExtraDeliveryCost\n      currentDeliveryDuration\n      isOverloaded\n      address {\n        address\n        addressLine2\n      }\n    }\n    ...timeFieldPreferences\n    ...updateAddressFragment\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_2__["default"])(_templateObject(), _data_fragments_preferences_timeFieldPreferencesFragment_main__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, _data_fragments_preferences_updateAddressFragment_main__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z));


/***/ }),

/***/ 41989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ checkout; }
});

// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/data/fragments/checkout/billingFragment.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment checkoutBillingPreferences on Preference {\n    _id\n    billing\n    website {\n      _id\n      billingParamsSchema\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var billingFragment = ((0,lib["default"])(_templateObject()));

// EXTERNAL MODULE: ./src/data/fragments/checkout/deliveryFragment.ts
var deliveryFragment = __webpack_require__(88511);
;// CONCATENATED MODULE: ./src/data/fragments/checkout/orderParamsFragment.ts
function orderParamsFragment_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function orderParamsFragment_templateObject() {
    var data = orderParamsFragment_taggedTemplateLiteral([
        "\n  fragment checkoutOrderParamsPreferences on Preference {\n    _id\n    orderParams\n    website {\n      _id\n      menuConfiguration {\n        orderParamsSchema\n      }\n    }\n  }\n"
    ]);
    orderParamsFragment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var orderParamsFragment = ((0,lib["default"])(orderParamsFragment_templateObject()));

;// CONCATENATED MODULE: ./src/data/fragments/checkout/paymentFragment.ts
function paymentFragment_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function paymentFragment_templateObject() {
    var data = paymentFragment_taggedTemplateLiteral([
        "\n  fragment checkoutPaymentPreferences on Preference {\n    _id\n    paymentType\n    cashAmount\n    nationalId\n    otherPaymentType\n    cardId\n    card {\n      _id\n      brandId\n      last4\n      brandName\n      paymentType\n      cardType\n    }\n    store {\n      _id\n      availablePaymentTypes\n      hideTip\n    }\n    website {\n      _id\n      otherPaymentTypes\n    }\n    user {\n      _id\n      cards {\n        _id\n        brandId\n        brandName\n        last4\n        paymentType\n        cardType\n      }\n    }\n  }\n"
    ]);
    paymentFragment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var paymentFragment = ((0,lib["default"])(paymentFragment_templateObject()));

;// CONCATENATED MODULE: ./src/data/fragments/checkout/profileFragment.ts
function profileFragment_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function profileFragment_templateObject() {
    var data = profileFragment_taggedTemplateLiteral([
        "\n  fragment checkoutProfilePreferences on Preference {\n    _id\n    sessionEmail\n    user {\n      _id\n      name\n      email\n      phone\n      profile {\n        firstName\n        lastName\n      }\n    }\n  }\n"
    ]);
    profileFragment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var profileFragment = ((0,lib["default"])(profileFragment_templateObject()));

// EXTERNAL MODULE: ./src/data/fragments/cartFragment/cartItemFragment.main.ts
var cartItemFragment_main = __webpack_require__(90932);
;// CONCATENATED MODULE: ./src/data/fragments/checkout/resumeFragment.ts
function resumeFragment_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function resumeFragment_templateObject() {
    var data = resumeFragment_taggedTemplateLiteral([
        "\n  fragment checkoutResumePreferences on Preference {\n    _id\n    deliveryType\n    channel\n    address {\n      _id\n    }\n    time\n    paymentType\n    tipAmount\n    tipPercentage\n    cashAmount\n    nationalId\n    otherPaymentType\n    menuId\n    bagsRequired\n    store {\n      _id\n      hasDelayInAcceptingOrders\n      activeAlertMessage\n      activeAlertClosedMessage\n      hideTip\n    }\n    website {\n      _id\n      noTipByDefault\n    }\n    cardId\n    couponCode\n    cart {\n      specialRequirementsIds\n      deliveryType\n      deliveryFee\n      hasDynamicDeliveryFee\n      menuId\n      itemsPrice\n      acceptsTip\n      hasFixedAmountTips\n      tipOptions\n      tipPercentagesOptions\n      calculatedTipAmount\n      originalItemsPrice: itemsPrice(includeDiscount: false)\n      totalPrice\n      amountToPay\n      bagAmount\n      maxBagsAllowed\n      pointsDetails {\n        amount\n        name\n      }\n      couponStatus {\n        couponId\n        code\n        errorMessage\n        name\n        discount\n      }\n      loyaltyTransactionStatus {\n        transactionId\n        loyaltyName\n        discount\n      }\n      items {\n        ...resumeCartItem\n      }\n      benefits\n    }\n    reducedDemand {\n      enabled\n      message\n    }\n  }\n  ",
        "\n"
    ]);
    resumeFragment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var resumeFragment = ((0,lib["default"])(resumeFragment_templateObject(), cartItemFragment_main/* default */.Z));

;// CONCATENATED MODULE: ./src/data/fragments/checkout/index.ts
function checkout_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function checkout_templateObject() {
    var data = checkout_taggedTemplateLiteral([
        "\n  fragment checkoutPreferences on Preference {\n    _id\n    websiteId\n    storeId\n    deliveryType\n    menuId\n    sessionEmail\n    sessionEmailHasAccount\n    sessionEmailHasName\n    sessionPhone\n    chatCommerceType\n    loyaltyProgram\n    ...checkoutResumePreferences\n    ...checkoutDeliveryPreferences\n    ...checkoutPaymentPreferences\n    ...checkoutProfilePreferences\n    ...checkoutOrderParamsPreferences\n    ...checkoutBillingPreferences\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    checkout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







/* harmony default export */ var checkout = ((0,lib["default"])(checkout_templateObject(), resumeFragment, deliveryFragment/* default */.Z, paymentFragment, profileFragment, orderParamsFragment, billingFragment));


/***/ }),

/***/ 31000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DeliveryFeeText; }
/* harmony export */ });
/* harmony import */ var _i18n_formatNumber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78263);

function DeliveryFeeText(param) {
    var address = param.address, deliveryFee = param.deliveryFee;
    if (!address) return "Por calcular";
    if (deliveryFee === 0) return "Gratis";
    return (0,_i18n_formatNumber__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(deliveryFee, "money");
};


/***/ }),

/***/ 30700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Content; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Button/index.tsx
var Button = __webpack_require__(40076);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/index.tsx + 1 modules
var DeliveryWizard = __webpack_require__(16312);
// EXTERNAL MODULE: ./src/components/SafeSuspenseLoading/index.tsx
var SafeSuspenseLoading = __webpack_require__(11501);
// EXTERNAL MODULE: ./src/data/queries/preferences/getMyOrderPreferencesSlim.main.ts
var getMyOrderPreferencesSlim_main = __webpack_require__(63879);
// EXTERNAL MODULE: ./src/helpers/analytics/events/index.ts + 3 modules
var events = __webpack_require__(54646);
// EXTERNAL MODULE: ./src/helpers/analytics/sendEvents.ts
var sendEvents = __webpack_require__(76110);
// EXTERNAL MODULE: ./src/hooks/useEventsBaseProperties.ts
var useEventsBaseProperties = __webpack_require__(87037);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./src/page-components/Order/CartLoadingContext.tsx
var CartLoadingContext = __webpack_require__(10177);
// EXTERNAL MODULE: ./src/page-components/Order/useLayout.ts
var useLayout = __webpack_require__(88641);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/hooks/useCartDetails.main.ts
var useCartDetails_main = __webpack_require__(98769);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/Item/index.tsx + 3 modules
var Item = __webpack_require__(28102);
// EXTERNAL MODULE: ./src/i18n/formatNumber/Component.tsx
var Component = __webpack_require__(18085);
// EXTERNAL MODULE: ./src/components/Money/Bags/Quantity/index.tsx
var Quantity = __webpack_require__(7737);
// EXTERNAL MODULE: ./src/components/Money/Bags/styles.module.css
var styles_module = __webpack_require__(15292);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Money/Bags/index.tsx





function Bags(props) {
    var deliveryType = props.deliveryType, bagAmount = props.bagAmount;
    var renderLine = function(label, value, style) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: style || (styles_module_default()).line,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).label,
                    children: label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: value
                })
            ]
        });
    };
    if (!bagAmount) return null;
    if (deliveryType !== "go") return renderLine("Bolsas", /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
        value: bagAmount
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).head,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).quantity,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Quantity/* default */.Z, {
                        bagsRequired: props.bagsRequired,
                        calculatedBagsRequired: props.calculatedBagsRequired,
                        maxBagsAllowed: props.maxBagsAllowed
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).name,
                    children: "Bolsas"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                        value: bagAmount
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/helpers/misc/deliveryFeeText.ts
var deliveryFeeText = __webpack_require__(31000);
// EXTERNAL MODULE: ./src/helpers/track/useTrackEcommerceEvent.ts + 6 modules
var useTrackEcommerceEvent = __webpack_require__(55870);
// EXTERNAL MODULE: ./src/hooks/useIsSpecialLayout.ts
var useIsSpecialLayout = __webpack_require__(5455);
// EXTERNAL MODULE: ./src/i18n/formatNumber/index.ts + 1 modules
var formatNumber = __webpack_require__(78263);
// EXTERNAL MODULE: ./src/page-components/Layout/useInitialData.ts
var useInitialData = __webpack_require__(62832);
// EXTERNAL MODULE: ./src/page-components/Order/warningBox.tsx
var warningBox = __webpack_require__(1829);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/Resume/hooks/usePreferencesForResume.main.ts
var usePreferencesForResume_main = __webpack_require__(31669);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/Resume/styles.module.css
var Resume_styles_module = __webpack_require__(8744);
var Resume_styles_module_default = /*#__PURE__*/__webpack_require__.n(Resume_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Cart/Content/Resume/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




















var DynamicDelivery = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6461).then(__webpack_require__.bind(__webpack_require__, 86461));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86461)
            ];
        }
    }
});
function Resume(props) {
    var ref5, ref1, ref2;
    var whatsappChatCommerceNumber = props.whatsappChatCommerceNumber;
    var t = (0,esm/* useTranslation */.$G)().t;
    var i18nWebsite = "website:order.cart.content.resume";
    var i18nGeneric = "generic:fields";
    var i18nProduct = "order.products.productsContent.selectProduct";
    var router = (0,next_router.useRouter)();
    var isSpecialLayout = (0,useIsSpecialLayout/* default */.Z)();
    var ref3 = (0,react.useState)(false), redirecting = ref3[0], setRedirecting = ref3[1];
    var website = (0,useInitialData/* default */.Z)().website;
    var checkoutPath = "/checkout";
    var baseEventProperties = (0,useEventsBaseProperties/* default */.Z)();
    (0,react.useEffect)(function() {
        router.prefetch(checkoutPath);
    }, [
        router,
        checkoutPath
    ]);
    var preferences = (0,usePreferencesForResume_main/* default */.Z)();
    var cart = preferences.cart, address = preferences.address, menuId = preferences.menuId;
    var ref4 = cart !== null && cart !== void 0 ? cart : {}, itemsPrice = ref4.itemsPrice, realPrice = ref4.realPrice, totalPrice = ref4.totalPrice, bagAmount = ref4.bagAmount, items = ref4.items, deliveryType = ref4.deliveryType, storeId = ref4.storeId;
    var productAmount = 0;
    items === null || items === void 0 ? void 0 : items.forEach(function(item) {
        productAmount += item.amount;
    });
    var trackEcommerceEvent = (0,useTrackEcommerceEvent/* default */.Z)();
    var goToReview = function() {
        setRedirecting(true);
        trackEcommerceEvent(useTrackEcommerceEvent/* ECOMMERCE_EVENTS.INITCHECKOUT */.X.INITCHECKOUT, {
            cart: cart
        });
        var _length;
        (0,sendEvents/* sendEvent */.q)(events/* EVENTS.purchase.continueToCheckout */.F.purchase.continueToCheckout, _objectSpread({}, baseEventProperties, {
            subTotalPrice: itemsPrice !== null && itemsPrice !== void 0 ? itemsPrice : 0,
            cartitemsAmount: (_length = items.length) !== null && _length !== void 0 ? _length : 0,
            productAmount: productAmount,
            menuId: menuId !== null && menuId !== void 0 ? menuId : ""
        }));
        router.push(checkoutPath);
    };
    var goToWhatsapp = function() {
        setRedirecting(true);
        trackEcommerceEvent(useTrackEcommerceEvent/* ECOMMERCE_EVENTS.INITCHECKOUT */.X.INITCHECKOUT, {
            cart: cart
        });
        var _length;
        (0,sendEvents/* sendEvent */.q)(events/* EVENTS.purchase.continueToCheckout */.F.purchase.continueToCheckout, _objectSpread({}, baseEventProperties, {
            subTotalPrice: itemsPrice !== null && itemsPrice !== void 0 ? itemsPrice : 0,
            cartitemsAmount: (_length = items.length) !== null && _length !== void 0 ? _length : 0,
            productAmount: productAmount,
            menuId: menuId !== null && menuId !== void 0 ? menuId : ""
        }));
        if (!whatsappChatCommerceNumber) {
            var justoBotPhoneNumber = "18453032928" // TODO: CRUD and fetch from backend
            ;
            router.push("/whatsapp-redirect?phone=".concat(justoBotPhoneNumber, "&text=Completar"));
            return;
        }
        router.push("/whatsapp-redirect?phone=".concat(whatsappChatCommerceNumber.replace("+", ""), "&text=Completar"));
    };
    var hasAnyOutOfStock = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (item.isOutOfStock) return true;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return false;
    };
    var amountToReachMinimum = function() {
        if (!website) return;
        if (!website.minimumOrderPrice) return;
        if (!itemsPrice) return;
        var amount = website.minimumOrderPrice - itemsPrice;
        if (amount > 0) return amount;
        return 0;
    };
    var renderDiscount = function() {
        if (itemsPrice === realPrice) return;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Resume_styles_module_default()).discount,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Resume_styles_module_default()).label,
                    children: t("".concat(i18nWebsite, ".labelDiscount"))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        "- ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                            value: realPrice - itemsPrice
                        }),
                        " "
                    ]
                })
            ]
        });
    };
    var renderSubTotal = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Resume_styles_module_default()).itemsPrice,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Resume_styles_module_default()).label,
                    children: t("".concat(i18nWebsite, ".labelProductsTotal"))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: (0,formatNumber/* default */.Z)(realPrice, "money")
                })
            ]
        });
    };
    var renderDeliveryFee = function() {
        var ref;
        if (deliveryType !== "delivery") return null;
        if (!storeId) return null;
        var deliveryFee = cart.deliveryFee;
        var dynamicFee = preferences && (preferences === null || preferences === void 0 ? void 0 : (ref = preferences.store) === null || ref === void 0 ? void 0 : ref.currentExtraDeliveryCost) > 0;
        var deliveryContent = (0,deliveryFeeText/* default */.Z)({
            address: address,
            deliveryFee: deliveryFee
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Resume_styles_module_default()).itemsPrice,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Resume_styles_module_default()).label,
                    children: t("".concat(i18nGeneric, ".dispatch"))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: dynamicFee ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicDelivery, {
                        value: deliveryContent
                    }) : deliveryContent
                })
            ]
        });
    };
    var renderButton = function() {
        var disabled = hasAnyOutOfStock();
        if (disabled) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Resume_styles_module_default()).button,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    primary: true,
                    disabled: true,
                    children: t("".concat(i18nWebsite, ".labelProductsOutStock"))
                })
            });
        }
        var amountToReach = amountToReachMinimum();
        if (amountToReach) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Resume_styles_module_default()).button,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        primary: true,
                        disabled: true,
                        children: t("".concat(i18nWebsite, ".labelNotReachedMin"))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "description",
                        style: {
                            marginTop: 5
                        },
                        children: t("".concat(i18nWebsite, ".labelAddMoreProducts"), {
                            money: (0,formatNumber/* default */.Z)(amountToReach, "money")
                        })
                    })
                ]
            });
        }
        if (isSpecialLayout === "chat") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Resume_styles_module_default()).button, (Resume_styles_module_default()).whatsappButton),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    primary: true,
                    onClick: goToWhatsapp,
                    loading: redirecting,
                    children: t("".concat(i18nWebsite, ".labelCompleteOrderInWhatsapp"))
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Resume_styles_module_default()).button,
            children: [
                !(preferences === null || preferences === void 0 ? void 0 : preferences.store) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(warningBox/* default */.Z, {
                    children: t("".concat(i18nProduct, ".inner.actions.labelAddAddressOrSelectStore"))
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    primary: true,
                    onClick: goToReview,
                    loading: redirecting,
                    disabled: !(preferences === null || preferences === void 0 ? void 0 : preferences.store),
                    children: t("".concat(i18nWebsite, ".labelContinueWithMyOrder"))
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Resume_styles_module_default()).container,
        children: [
            renderSubTotal(),
            renderDeliveryFee(),
            renderDiscount(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Bags, {
                deliveryType: preferences.deliveryType,
                bagAmount: (ref5 = preferences.cart) === null || ref5 === void 0 ? void 0 : ref5.bagAmount,
                bagsRequired: preferences.bagsRequired,
                calculatedBagsRequired: (ref1 = preferences.cart) === null || ref1 === void 0 ? void 0 : ref1.calculatedBagsRequired,
                maxBagsAllowed: (ref2 = preferences.cart) === null || ref2 === void 0 ? void 0 : ref2.maxBagsAllowed
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Resume_styles_module_default()).total,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Resume_styles_module_default()).label,
                        children: t("".concat(i18nWebsite, ".labelTotal"))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                                value: totalPrice + bagAmount
                            }),
                            " "
                        ]
                    })
                ]
            }),
            renderButton()
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/useWhatsAppCommerceNumber.ts
var useWhatsAppCommerceNumber = __webpack_require__(33298);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/styles.module.css
var Content_styles_module = __webpack_require__(10658);
var Content_styles_module_default = /*#__PURE__*/__webpack_require__.n(Content_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Cart/Content/index.tsx
function Content_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Content_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Content_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


















function Content() {
    var ref10, ref1;
    var layout = (0,useLayout/* default */.Z)();
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var data = (0,getMyOrderPreferencesSlim_main/* useMyOrderPreferencesSlim */.b)(websiteId, {
        partial: false
    }).data;
    var cart = (0,useCartDetails_main/* default */.Z)();
    var ref2;
    var storeId = ((ref2 = data === null || data === void 0 ? void 0 : data.preferences) !== null && ref2 !== void 0 ? ref2 : {}).storeId;
    var ref3 = (0,react.useState)(layout === "v2" && !storeId ? false : true), showCart = ref3[0], setShowCart = ref3[1];
    var t = (0,esm/* useTranslation */.$G)().t;
    var i18nWebsite = "website:order.cart";
    var i18nGeneric = "generic:fields";
    var whatsappChatCommerceNumber = (0,useWhatsAppCommerceNumber/* default */.Z)();
    var loading = (0,CartLoadingContext/* useCartLoading */.k6)().loading;
    var baseEventProperties = (0,useEventsBaseProperties/* default */.Z)();
    var productAmount = 0;
    var subTotalPrice = 0;
    cart === null || cart === void 0 ? void 0 : (ref10 = cart.items) === null || ref10 === void 0 ? void 0 : ref10.forEach(function(item) {
        productAmount += item.amount;
        subTotalPrice += item.unitPrice * item.amount;
    });
    (0,react.useEffect)(function() {
        var ref, ref5, ref6, ref7;
        if (!(data === null || data === void 0 ? void 0 : (ref = data.preferences) === null || ref === void 0 ? void 0 : ref._id)) return;
        var ref8, ref9;
        (0,sendEvents/* sendEvent */.q)(events/* EVENTS.purchase.cartPageViewed */.F.purchase.cartPageViewed, Content_objectSpread({}, baseEventProperties, {
            cartItemsAmount: (ref8 = cart === null || cart === void 0 ? void 0 : (ref5 = cart.items) === null || ref5 === void 0 ? void 0 : ref5.length) !== null && ref8 !== void 0 ? ref8 : 0,
            productAmount: productAmount,
            subTotalPrice: subTotalPrice,
            isScheduledOrder: (data === null || data === void 0 ? void 0 : (ref6 = data.preferences) === null || ref6 === void 0 ? void 0 : ref6.time) !== "now",
            menuId: (ref9 = data === null || data === void 0 ? void 0 : (ref7 = data.preferences) === null || ref7 === void 0 ? void 0 : ref7.menuId) !== null && ref9 !== void 0 ? ref9 : ""
        }));
    }, [
        data === null || data === void 0 ? void 0 : (ref1 = data.preferences) === null || ref1 === void 0 ? void 0 : ref1._id
    ]);
    if (!cart) return null;
    if (!showCart) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Content_styles_module_default()).optionsContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspenseLoading/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryWizard/* default.AsComponent */.Z.AsComponent, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Content_styles_module_default()).buttonContinue,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: !storeId,
                        onClick: function() {
                            return setShowCart(true);
                        },
                        primary: true,
                        children: t("".concat(i18nGeneric, ".continue"))
                    })
                })
            ]
        });
    }
    if (cart.items.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Content_styles_module_default()).empty,
            children: t("".concat(i18nWebsite, ".emptyCart"))
        });
    }
    if (showCart) {
        var ref4;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Content_styles_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Content_styles_module_default()).items,
                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex animate-pulse px-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-20 w-full bg-gray-200 rounded"
                        })
                    }) : cart.items.map(function(item) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Item/* default */.Z, {
                            item: item,
                            readOnly: false,
                            amountClassname: "",
                            menuId: (ref4 = data === null || data === void 0 ? void 0 : (ref = data.preferences) === null || ref === void 0 ? void 0 : ref.menuId) !== null && ref4 !== void 0 ? ref4 : ""
                        }, item._id);
                    })
                }),
                cart.items.length > 5 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Content_styles_module_default()).shadow
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Resume, {
                    whatsappChatCommerceNumber: whatsappChatCommerceNumber
                })
            ]
        });
    }
};


/***/ }),

/***/ 42124:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"xx2Lj14c6QC-rE8GEJp0G","select":"_16FGiRyaY5QWm5L-0_5EkY secondaryBackgroundColor textColor backgroundBorderColor"};

/***/ }),

/***/ 15292:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2EeC5UeCLNph8Wve0qZ1jY cartItem backgroundBorderColor","head":"_29-A11DS_oz_e316wACNTr","name":"_39dYfHkWUnTkEi1C-DhWW-","line":"_3iDLTzqWwinZiXi4FLvvU2","label":"dfaFe8BY_DNimADNpPAIB","quantity":"_2UsW3iYqMKd-i8W853d4lX"};

/***/ }),

/***/ 8744:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2afy5O68bYwlybgRzAiiv1","row":"STyBpJnmQl5_aXes1SmKB","itemsPrice":"_1Rj3LvzCGDm64X9KAyz9Gr STyBpJnmQl5_aXes1SmKB","discount":"_1NmshcgeglDgJ0dkot1ARM STyBpJnmQl5_aXes1SmKB","total":"_3yim9IxqOhX8YA919uUUDr STyBpJnmQl5_aXes1SmKB","totalOnTable":"_1vdE0k7FgyHqFLUiLhPpda STyBpJnmQl5_aXes1SmKB","button":"_1d78VmrKdLRfpj62_yqwIW","error":"_3nXaN_0Qp35ohfW6fieXRD animated shake"};

/***/ }),

/***/ 10658:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"DGJHGnSi0Ay-FkL9f2An8 cartContainer","empty":"_2w5_689wrIb7IPXZt8Aya2 descriptionTextColor","closed":"_2gHYYUjYLixq3x4BD8l-uJ","storeName":"OgxB2HF0_w3UACU6yoQFa","items":"_1VEcuxgBRZndK-8WxGPOYP","optionsContent":"_1z_LpH4CG8awgIKZQnFFJ_","buttonContinue":"_26i_tqg9Cl_oQvssIDBH8n","tabsButtons":"_2QoIaBV6gwfwogc0QbSFN3","option":"zjrcGTDW7KMG-3ONrNlho","active":"_3fnsBOIQc2WK6Pw8epsvGE","buttonCloseTable":"_2C7eRYjxOFVeOD8BVSZzq9"};

/***/ })

}]);